// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_core__Project_environment from "../core/project_environment.js";
import * as Mapre_wire__Json from "./json.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function fields(allowed, value) {
  const object_ = Js__Js_json.decodeObject(value);
  if (object_ !== undefined) {
    if (Stdlib__Array.for_all((function (key) {
        return Stdlib__List.mem(key, allowed);
      }), Object.keys(Caml_option.valFromOption(object_)))) {
      return;
    }
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "unsupported_environment_field"
      });
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "unsupported_environment_field"
    });
}

function optional(value, name) {
  const object_ = Js__Js_json.decodeObject(value);
  if (object_ !== undefined) {
    return Stdlib__Option.value(Js__Js_dict.get(Caml_option.valFromOption(object_), name), null);
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_environment_configuration"
    });
}

function dockerfile(value) {
  const match = Mapre_wire__Json.string(value, "kind");
  switch (match) {
    case "repository" :
      fields({
        hd: "kind",
        tl: {
          hd: "path",
          tl: /* [] */ 0
        }
      }, value);
      return {
        TAG: /* Repository */ 0,
        _0: Mapre_wire__Json.string(value, "path")
      };
    case "uploaded" :
      fields({
        hd: "kind",
        tl: {
          hd: "name",
          tl: {
            hd: "content",
            tl: /* [] */ 0
          }
        }
      }, value);
      return {
        TAG: /* Uploaded */ 1,
        name: Mapre_wire__Json.string(value, "name"),
        content: Mapre_wire__Json.text(value, "content")
      };
    default:
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "unsupported_dockerfile_source"
        });
  }
}

function $$arguments(value) {
  if (Caml_obj.caml_equal(value, null)) {
    return /* [] */ 0;
  }
  const object_ = Js__Js_json.decodeObject(value);
  if (object_ !== undefined) {
    return Stdlib__List.sort(Caml_obj.caml_compare, Stdlib__List.map((function (param) {
      const value = Js__Js_json.decodeString(param[1]);
      if (value !== undefined) {
        return [
          param[0],
          value
        ];
      }
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_build_argument"
        });
    }), Stdlib__Array.to_list(Js__Js_dict.entries(Caml_option.valFromOption(object_)))));
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_build_arguments"
    });
}

function decode(value) {
  try {
    const match = Mapre_wire__Json.string(value, "kind");
    let result;
    switch (match) {
      case "dockerfile" :
        fields({
          hd: "kind",
          tl: {
            hd: "dockerfile",
            tl: {
              hd: "context",
              tl: {
                hd: "target",
                tl: {
                  hd: "build_args",
                  tl: /* [] */ 0
                }
              }
            }
          }
        }, value);
        const target = optional(value, "target");
        result = {
          TAG: /* Dockerfile */ 0,
          _0: {
            dockerfile: dockerfile(Mapre_wire__Json.get(value, "dockerfile")),
            context: Mapre_wire__Json.string(value, "context"),
            target: Caml_obj.caml_equal(target, null) ? undefined : Mapre_wire__Json.string(value, "target"),
            build_args: $$arguments(optional(value, "build_args"))
          }
        };
        break;
      case "native" :
        fields({
          hd: "kind",
          tl: /* [] */ 0
        }, value);
        result = /* Native */ 0;
        break;
      default:
        throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
            MEL_EXN_ID: Mapre_wire__Json.Invalid,
            _1: "unsupported_environment"
          });
    }
    const code = Mapre_core__Project_environment.validate(result);
    if (code.TAG === /* Ok */ 0) {
      return {
        TAG: /* Ok */ 0,
        _0: result
      };
    } else {
      return {
        TAG: /* Error */ 1,
        _0: code._0
      };
    }
  }
  catch (raw_code){
    const code$1 = Caml_js_exceptions.internalToOCamlException(raw_code);
    if (code$1.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
      return {
        TAG: /* Error */ 1,
        _0: code$1._1
      };
    }
    throw code$1;
  }
}

function encode(config) {
  if (/* tag */ typeof config !== "object" && typeof config !== "function") {
    return Js__Js_dict.fromList({
      hd: [
        "kind",
        Mapre_wire__Json.str("native")
      ],
      tl: /* [] */ 0
    });
  }
  const config$1 = config._0;
  const path = config$1.dockerfile;
  let dockerfile;
  dockerfile = path.TAG === /* Repository */ 0 ? Js__Js_dict.fromList({
      hd: [
        "kind",
        Mapre_wire__Json.str("repository")
      ],
      tl: {
        hd: [
          "path",
          Mapre_wire__Json.str(path._0)
        ],
        tl: /* [] */ 0
      }
    }) : Js__Js_dict.fromList({
      hd: [
        "kind",
        Mapre_wire__Json.str("uploaded")
      ],
      tl: {
        hd: [
          "name",
          Mapre_wire__Json.str(path.name)
        ],
        tl: {
          hd: [
            "content",
            Mapre_wire__Json.str(path.content)
          ],
          tl: /* [] */ 0
        }
      }
    });
  return Js__Js_dict.fromList({
    hd: [
      "kind",
      Mapre_wire__Json.str("dockerfile")
    ],
    tl: {
      hd: [
        "dockerfile",
        dockerfile
      ],
      tl: {
        hd: [
          "context",
          Mapre_wire__Json.str(config$1.context)
        ],
        tl: {
          hd: [
            "target",
            Stdlib__Option.fold(null, Mapre_wire__Json.str, config$1.target)
          ],
          tl: {
            hd: [
              "build_args",
              Js__Js_dict.fromList(Stdlib__List.map((function (param) {
                return [
                  param[0],
                  Mapre_wire__Json.str(param[1])
                ];
              }), Stdlib__List.sort(Caml_obj.caml_compare, config$1.build_args)))
            ],
            tl: /* [] */ 0
          }
        }
      }
    }
  });
}

export {
  decode,
  encode,
}
/* Mapre_wire__Json Not a pure module */
